export default __webpack_public_path__ + "static/media/message.4f06b82c.gif";